import { adminRoot, appRoot } from "./defaultValues";

const data = [
  {
    id: "dashboard",
    icon: "iconsminds-dashboard",
    label: "menu.dashboard",
    to: `${appRoot}/`,
  },
  {
    id: "media",
    icon: "iconsminds-video",
    label: "menu.media",
    to: `${appRoot}/media`,
    // subs: [
    //   {
    //     icon: "simple-icon-paper-plane",
    //     label: "menu.second",
    //     to: `${adminRoot}/second-menu/second`,
    //   },
    // ],
  },
  {
    id: "reports",
    icon: "iconsminds-file",
    label: "menu.reports",
    to: `${appRoot}/reports`,
  },
  {
    id: "admin",
    icon: "iconsminds-administrator",
    label: "menu.admin",
    to: `${adminRoot}`,
    permission: {
      action: "manage",
      subject: "admin",
    },
  },

  // {
  //   id: 'reports',
  //   icon: 'iconsminds-three-arrow-fork',
  //   label: 'menu.reports',
  //   to: `${adminRoot}/reports`,
  //   roles: [UserRole.Admin, UserRole.Editor],
  // },
  // {
  //   id: 'secondmenu',
  //   icon: 'iconsminds-three-arrow-fork',
  //   label: 'menu.second-menu',
  //   to: `${adminRoot}/second-menu`,
  //   // roles: [UserRole.Admin, UserRole.Editor],
  //   subs: [
  //     {
  //       icon: 'simple-icon-paper-plane',
  //       label: 'menu.second',
  //       to: `${adminRoot}/second-menu/second`,
  //     },
  //   ],
  // },
  // {
  //   id: 'blankpage',
  //   icon: 'iconsminds-bucket',
  //   label: 'menu.blank-page',
  //   to: `${adminRoot}/blank-page`,
  // },
  // {
  //   id: 'docs',
  //   icon: 'iconsminds-library',
  //   label: 'menu.docs',
  //   to: 'https://gogo-react-docs.coloredstrategies.com/',
  //   newWindow: true,
  // },
];
export default data;
